<div class="dropdownContainer">
  <select class="width" [(ngModel)]="selectedOption" (change)="setSelectedValue($event)">
    <option value="{{ null }}">{{ null }}</option>
    <option *ngFor="let option of options" value="{{ option.id }}">{{ option.name }}</option>
  </select>
  <div>
    <label *ngIf="showValidationError" class="textinput__errmsg__custom"><i class="err_icon icon-ico_error_toast"></i>{{ meta.errorMsg }}</label>
  </div>
</div>
